import { ErrorCauseData, GenericError, UnknownError } from '@cian/peperrors';

interface IParams {
  error: unknown;
  domain: string;
  message: string;
}

/**
 * @description
 * Проверяет и возвращает ошибку в формате GenericError
 */
export const getGenericLikeError = ({ error, domain, message }: IParams): GenericError => {
  if (GenericError.isLike(error)) {
    return error;
  }

  return new UnknownError({ domain, message, details: error as ErrorCauseData });
};
